import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import useHttp from "../../../Hooks/use-http";
import "./ViewRoute.css";

import startPoint from "../../../Assets/Pin_icon_green50.png";
import endPoint from "../../../Assets/Pin_icon50.png"
import studentDummyImage from "../../../Assets/new_student_marker.png";

let flag = 0;
let waypts = [];
let routeInfo = {};
const polyline1 = {
  strokeColor: "#00b0ff",
  strokeOpacity: 10.0,
  strokeWeight: 4,
};
const ViewRoute = (props) => {
  const [routeDetails, setRouteDetails] = useState([]);
  const authenticateUser = (data) => {
    // routeInfo = data?.Route[0];
    routeInfo=data?.RouteDetails
    let routeDetailss = data?.RouteDetails?.shuttleRoute;
    let arr = [];
    for (let i = 0; i < routeDetails?.length; i++) {
      if (arr.includes(routeDetails?.[i]?.stopName)) {
        let index = arr.indexOf(routeDetails[i]?.stopName);
        // routeInfo[index].name.push(routeInfo[i].name.toString());
        // routeInfo[index].mNumber.push(routeInfo[i].mNumber.toString());
        routeDetails.splice(i, 1);
        i--;
      }
      // console.log(filteredData);
      // console.log(filteredData[i],i);
      else arr.push(routeDetails?.[i]?.stopName);
    }
    setRouteDetails(routeDetailss);
  };

  const { isLoading, sendRequest } = useHttp();

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyDHdkmGjsfNqasFs6m9CooShFZsqWHcdUs&callback=myInitMap&libraries=places&v=weekly";
    script.async = true;
    document.body.appendChild(script);
  }, [routeDetails]);

  useEffect(() => {
    // if (flag > 0)
    sendRequest(
      {
        // url: "/api/v1/Route/GetRouteDetails",
        url: "/shuttleroute",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
         data: {
           routeID: props.routeId,

          }
        },
      },
      authenticateUser
    );
    // flag++;
  }, [sendRequest]);

  console.log("routeINfoojljjljl", routeInfo)

//   function myInitMap() {
//     let map = new window.google.maps.Map(
//       document.getElementById("map-viewModal"),
//       {
//         zoom: 11,
//         center: { lat: 23.0358311, lng: 72.5579656 },
//         mapTypeId: window.google.maps.MapTypeId.ROADMAP,
//         disableDefaultUI: true,
//         fullscreenControl: true,
//         zoomControl: true,
//       }
//     );
//     let directionsService = new window.google.maps.DirectionsService();

//     let directionsRenderer1 = new window.google.maps.DirectionsRenderer({
//       polylineOptions: polyline1,
//       suppressMarkers: true,
//     });

//     directionsRenderer1.setMap(map);
//     // let directionsRenderer2 = new window.google.maps.DirectionsRenderer({
//     //   polylineOptions: polyline2,
//     //   suppressMarkers: true,
//     // });

//     // directionsRenderer2.setMap(map);
//     waypts = [];
//     for (
//       let i = routeInfo.routeType?.toLowerCase() === "dropping" ? 1 : 0;
//       i <
//       (routeInfo?.routeType?.toLowerCase() === "dropping"
//         ? routeDetails?.length - 1
//         : routeDetails?.length - 2);
//       i++
//     ) {
//       // for (let i = 1; i < routeDetails?.length - 1; i++) { //  drop
//       // for (let i = 0; i < routeDetails?.length - 2; i++) {   //pickup

//       // waypts.push({
//       //   location: {
//       //     lat: parseInt(routeDetails[i]?.stopLatitude),
//       //     lng: parseInt(routeDetails[i]?.stopLongitude),
//       //   },
//       //   stopover: true,
//       // });

//       for (let i = 1; i < routeDetails?.length - 1; i++) {
//         waypts.push({
//           location: {
//             lat: parseFloat(routeDetails[i]?.stopLatitude), // Use parseFloat for precision
//             lng: parseFloat(routeDetails[i]?.stopLongitude),
//           },
//           stopover: true,
//         });
//       }
//     }

// // request changes -------------------------

//     // const request = {
//     //   origin: {
//     //     lat: parseInt (routeDetails[
//     //       routeInfo?.routeType?.toLowerCase() === "dropping"
//     //         ? 0
//     //         : routeDetails?.length - 1
//     //     ]?.stopLatitude),
//     //     lng: parseInt(routeDetails[
//     //       routeInfo?.routeType?.toLowerCase() === "dropping"
//     //         ? 0
//     //         : routeDetails?.length - 1
//     //     ]?.stopLongitude),
//     //   },
//     //   destination: {
//     //     lat: parseInt(routeDetails[
//     //       routeInfo?.routeType?.toLowerCase() === "dropping"
//     //         ? routeDetails?.length - 1
//     //         : routeDetails?.length - 2
//     //     ]?.stopLatitude),
//     //     lng: parseInt(routeDetails[
//     //       routeInfo?.routeType?.toLowerCase() === "dropping"
//     //         ? routeDetails?.length - 1
//     //         : routeDetails?.length - 2
//     //     ]?.stopLongitude),
//     //   }, //LD
//     //   waypoints: waypts,
//     //   travelMode: window.google.maps.TravelMode.DRIVING,
//     // };


//     const request = {
//       origin: {
//         lat: parseFloat(routeDetails[0]?.stopLatitude), // Always the first stop
//         lng: parseFloat(routeDetails[0]?.stopLongitude),
//       },
//       destination: {
//         lat: parseFloat(routeDetails[routeDetails?.length - 1]?.stopLatitude), // Always the last stop
//         lng: parseFloat(routeDetails[routeDetails?.length - 1]?.stopLongitude),
//       },
//       waypoints: waypts, // Includes all intermediate stops
//       travelMode: window.google.maps.TravelMode.DRIVING,
//     };
    

//     // const infoWindow = new window.google.maps.InfoWindow();
//     // console.log(waypts);
//     // debugger;
//     directionsService.route(request, function (response, status) {
//       // console.log("after");
//       if (status == window.google.maps.DirectionsStatus.OK) {
//         // directionsRenderer2.setDirections(response); // Add route to the map
//         directionsRenderer1?.setDirections(response); // Add route to the map
//         // console.log(response.routes[0].start_location);
//       }
//     });

//     const infoWindow = new window.google.maps.InfoWindow();
//     let icon;
//     let myTitle;

//     // console.log(filteredData);
//     // routeDetails?.forEach((position, i) => {
//     //   if (
//     //     (routeInfo?.routeType?.toLowerCase() === "dropping" &&
//     //       position.stopNumber === 0) ||
//     //     (routeInfo?.routeType?.toLowerCase() === "picking" &&
//     //       position?.stopNumber === routeDetails?.length - 1)
//     //   ) {
//     //     icon = startPoint;
//     //     myTitle = `<div><h3>${position?.stopName}</h3></div>`;
//     //   } else {
//     //     icon = studentDummyImage;
//     //     myTitle = `<div id="infowindow-container" ><h3>${
//     //       position.stopName
//     //     }`;
//     //   }

//     //   let marker = new window.google.maps.Marker({
//     //     position: { lat: parseInt(position?.stopLatitude), lng: parseInt(position?.stopLongitude) },
//     //     map,
//     //     myTitle,
//     //     icon,
//     //     optimized: false,
//     //   });

//     //   marker.addListener("mouseover", () => {
//     //     // infoWindow.close();
//     //     infoWindow.seHeadertContent(marker.myTitle);
//     //     infoWindow.open(marker.getMap(), marker);
//     //   });
//     // });

//     routeDetails?.forEach((stop, index) => {
//       let icon, myTitle;
    
//       // Set different icons and titles for start, waypoints, and end
//       if (index === 0) {
//         // Start point
//         icon = startPoint; // Green pin for the start
//         myTitle = `<div><h3>Start: ${stop?.stopName}</h3></div>`;
//       } else if (index === routeDetails?.length - 1) {
//         // End point
//         icon = startPoint; // Use the same icon or a different one for the end
//         myTitle = `<div><h3>End: ${stop?.stopName}</h3></div>`;
//       } else {
//         // Waypoints
//         icon = studentDummyImage; // Default icon for waypoints
//         myTitle = `<div><h3>Stop: ${stop?.stopName}</h3></div>`;
//       }
    
//       // Create marker
//       const marker = new window.google.maps.Marker({
//         position: {
//           lat: parseFloat(stop?.stopLatitude), // Use parseFloat for latitude and longitude
//           lng: parseFloat(stop?.stopLongitude),
//         },
//         map,
//         icon,
//         optimized: false,
//       });
    
//       // Add info window for marker
//       const infoWindow = new window.google.maps.InfoWindow({
//         content: myTitle,
//       });
    
//       marker.addListener("mouseover", () => {
//         infoWindow.open(map, marker);
//       });
    
//       marker.addListener("mouseout", () => {
//         infoWindow.close();
//       });
//     });
    
//   }

function myInitMap() {
  const map = new window.google.maps.Map(
    document.getElementById("map-viewModal"),
    {
      zoom: 11,
      center: { lat: 23.0358311, lng: 72.5579656 },
      mapTypeId: window.google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      fullscreenControl: true,
      zoomControl: true,
    }
  );

  const directionsService = new window.google.maps.DirectionsService();
  const directionsRenderer1 = new window.google.maps.DirectionsRenderer({
    polylineOptions: polyline1,
    suppressMarkers: true, // Suppress default markers
  });

  directionsRenderer1.setMap(map);

  // Add waypoints
  waypts = [];
  for (let i = 1; i < routeDetails?.length - 1; i++) {
    waypts.push({
      location: {
        lat: parseFloat(routeDetails[i]?.stopLatitude),
        lng: parseFloat(routeDetails[i]?.stopLongitude),
      },
      stopover: true,
    });
  }

  const request = {
    origin: {
      lat: parseFloat(routeDetails[0]?.stopLatitude),
      lng: parseFloat(routeDetails[0]?.stopLongitude),
    },
    destination: {
      lat: parseFloat(routeDetails[routeDetails?.length - 1]?.stopLatitude),
      lng: parseFloat(routeDetails[routeDetails?.length - 1]?.stopLongitude),
    },
    waypoints: waypts,
    travelMode: window.google.maps.TravelMode.DRIVING,
  };

  directionsService.route(request, function (response, status) {
    if (status === window.google.maps.DirectionsStatus.OK) {
      directionsRenderer1.setDirections(response);
    }
  });

  // Add markers for all stops
  routeDetails?.forEach((stop, index) => {
    let icon, myTitle;

    if (index === 0) {
      icon = startPoint;
      myTitle = `<div><h3>Start: ${stop?.stopName}</h3></div>`;
    } else if (index === routeDetails?.length - 1) {
      icon = endPoint;
      myTitle = `<div><h3>End: ${stop?.stopName}</h3></div>`;
    } else {
      icon = studentDummyImage;
      myTitle = `<div><h3>Stop: ${stop?.stopName}</h3></div>`;
    }

    const marker = new window.google.maps.Marker({
      position: {
        lat: parseFloat(stop?.stopLatitude),
        lng: parseFloat(stop?.stopLongitude),
      },
      map,
      icon,
      optimized: false,
    });

    const infoWindow = new window.google.maps.InfoWindow({
      content: myTitle,
    });

    marker.addListener("mouseover", () => {
      infoWindow.open(map, marker);
    });

    marker.addListener("mouseout", () => {
      infoWindow.close();
    });
  });
}

  window.myInitMap = myInitMap;

  return (
    <div className="viewRouteContainer">
      <header>
        <span>{props?.routeName}</span>
        <span
          style={{ cursor: "pointer" }}
          onClick={() => props.setIsViewRouteClicked(false)}
        >
          X
        </span>
      </header>
      <div id="map-viewModal"></div>
    </div>
  );
};

export default ViewRoute;
